import {Customer,} from '../types';
import {
    SimplePageContentWrapper,
    TabbedComponent,
    TabComponentTab,
} from "@flexinet/ui-components";
import {
    Grid,
    Group,
    Stack
} from "@mantine/core";
import {IndexPage as OrdersPage} from "../../orders/pages/IndexPage.tsx";
import {IndexPage as InvoicesPage} from "../../invoices/pages/IndexPage.tsx";
import {IndexPage as SubscriptionsPage} from "../../customer-subscriptions/pages/IndexPage.tsx";
import {IndexPage as PaymentProfilesPage} from "../../payment-profiles/pages/IndexPage.tsx";

import {MetadataPropertyCard} from "./MetadataPropertyCard.tsx";
import {InformationPropertyCard} from "./InformationPropertyCard.tsx";
import {ContactInfoPropertyCard} from "./ContactInfoPropertyCard.tsx";
import {CurrentInvoiceWidget} from "./CurrentInvoiceWidget.tsx";
import {LastPaymentWidget} from "./LastPaymentWidget.tsx";
import {BillingInfoPropertyCard} from "./BillingInfoPropertyCard.tsx";
import {IndexPage as ProviderMappingsPage} from "../../provider-mappings/pages/IndexPage.tsx";
import { useState } from 'react';


export const Profile = ({record}: { record: Customer, onRecordUpdate?: (updates: Partial<Customer>) => void }) => {
    const [currentCustomer] = useState(record);

    const tabs = [
        {
            title: 'Overview',
            component: (
                <SimplePageContentWrapper>
                    <Group grow gap={'xl'}>
                        <CurrentInvoiceWidget record={currentCustomer}/>
                        <LastPaymentWidget record={currentCustomer}/>
                    </Group>
                </SimplePageContentWrapper>
            ),
        },
        {
            title: 'Subscriptions',
            component: <SubscriptionsPage/>,
        },
        {
            title: 'Orders',
            component: <OrdersPage/>,
        },
        {
            title: 'Invoices',
            component: <InvoicesPage/>,
        },
        {
            title: 'Payment Profiles',
            component: <PaymentProfilesPage customerId={currentCustomer.id}/>,
        },
        {
            title: 'Billing Provider Mappings',
            component: <ProviderMappingsPage customerId={currentCustomer.id}/>,
        },
    ] as TabComponentTab[];

    return (
        <Grid>
            <Grid.Col span={{
                base: 12,
                lg: 4
            }}>
                <Stack gap={'xl'}>
                    <InformationPropertyCard record={currentCustomer}/>
                    <ContactInfoPropertyCard record={currentCustomer}/>
                    <BillingInfoPropertyCard record={currentCustomer}/>
                    <MetadataPropertyCard record={currentCustomer}/>
                </Stack>
            </Grid.Col>
            <Grid.Col span={{
                base: 12,
                lg: 8
            }}>
                <TabbedComponent tabs={tabs}/>
            </Grid.Col>
        </Grid>
    );


};
